export default __webpack_public_path__ + "static/media/IC_address_book.572de3fb.svg";